import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ManifestApiErrorTypes, ManifestApiError } from './manifest.errors';
import { Manifest } from 'src/app/admin/models/manifest.model';

const BASE_URL = `${environment.apiConfig.url}/admin/manifests`;
const MAX_MANIFESTS_PER_PAGE = 50;

@Injectable()
export class ManifestService {
  constructor(private http: HttpClient) {}

  loadManifests(): Observable<Manifest[]> {
    const url = BASE_URL;
    const params = new HttpParams({
      fromObject: {
        'filter[limit]': String(MAX_MANIFESTS_PER_PAGE),
        'filter[order]': 'datetimeAdded DESC',
      },
    });

    return this.http
      .get<Manifest[]>(url, { params })
      .pipe(
        catchError((err) =>
          throwError(new ManifestApiError(ManifestApiErrorTypes.LoadManifestsError, err)),
        ),
      );
  }

  createManifest(description: string, values: Record<string, unknown>): Observable<Manifest> {
    const url = BASE_URL;
    const newManifest = {
      description,
      values,
    };
    return this.http
      .post<Manifest>(url, newManifest)
      .pipe(
        catchError((err) =>
          throwError(new ManifestApiError(ManifestApiErrorTypes.CreateManifestError, err)),
        ),
      );
  }

  getManifest(id: number) {
    const url = `${BASE_URL}/${id}`;

    return this.http
      .get<Manifest>(url)
      .pipe(
        catchError((err) =>
          throwError(new ManifestApiError(ManifestApiErrorTypes.ManifestNotFoundError, err)),
        ),
      );
  }
}
